<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-input
    ref="input"
    type="text" 
    :label="label" 
    :name="name" 
    :value="value"
    @input="$emit('input', $event)"
    v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  name: "c-protocolo-cid-atestado",
  props: {
    label: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/CidAtestado.vue